import { inject, Injectable } from "@angular/core";
import { FuseConfirmationService } from "@fuse/services/confirmation";
import { IConfirmDialogConfig } from "./confirm-dialog.config.interface";

@Injectable({
	providedIn: "root"
})
export class ConfirmationDialogService {

	private readonly _fuseConfirmService = inject(FuseConfirmationService);

	private static _instance : ConfirmationDialogService | null = null;

	constructor() {
		ConfirmationDialogService._instance = this;
	}

	public static getInstance() {
		return ConfirmationDialogService._instance;
	}
	
	open(confirmData: IConfirmDialogConfig) {
		switch (confirmData.type) {
			case "warn":
				return this._warning(confirmData.title, confirmData.message);
			case "info":
				return this._info(confirmData.title, confirmData.message);
			default:
				break;
		}

		throw new Error("Confirmation type not accepted.");
	}

	private _warning(title: string, message: string) {
		return this._fuseConfirmService.open({
			title: title,
			message: message,
			icon: {
				show: true,
				name: "heroicons_outline:exclamation-triangle",
				color: "warn"
			},
			actions: {
				confirm: {
					show: true,
					label: "Sim",
					color: "warn"
				},
				cancel: {
					show: true,
					label: "Não"
				}
			},
			dismissible: true
		}).afterClosed();
	}

	private _info(title: string, message: string) {
		return this._fuseConfirmService.open({
			title: title,
			message: message,
			icon: {
				show: true,
				name: "heroicons_outline:information-circle",
				color: "primary"
			},
			actions: {
				confirm: {
					show: true,
					label: "Sim",
					color: "primary"
				},
				cancel: {
					show: true,
					label: "Não"
				}
			},
			dismissible: true
		}).afterClosed(); 
	}
}